/**
    * Returns the correct icon based on selectedConfig.
    * If no configType matches, returns the default icon (without configType).
    * Works with single string icon or array of icons.
    */

const getIconByConfigType = (iconConfig = [], selectedConfig = {}) => {
    // If it's a string, just return it (already default)
    if (!Array.isArray(iconConfig)) {
        // console.log('[ICON] Using static icon:', iconConfig);
        return iconConfig;
    }

    // Try to find a matching icon with configType
    const match = iconConfig.find(iconItem => {
        if (!iconItem.configType) return false; // skip default for now

        return Object.keys(iconItem.configType).every(key => {
            const selectedValue = selectedConfig[key];
            const allowedValues = iconItem.configType[key];
            return Array.isArray(allowedValues)
                ? allowedValues.includes(selectedValue)
                : allowedValues === selectedValue;
        });
    });

    // Return matched icon OR default (first icon without configType) OR first icon in array
    const finalIcon = match?.img || iconConfig.find(icon => !icon.configType)?.img || iconConfig[0]?.img;

    // console.log('[ICON] Selected icon:', finalIcon, { matchedRule: match?.configType, selectedConfig });
    return finalIcon;
};

export default getIconByConfigType;